import React from 'react';
import { Copy, Trash2, Split, Info, MoreVertical } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import type { TimesheetEntry } from '@/types/timesheet';

interface BookingInlineActionsProps {
  booking: TimesheetEntry;
  onDuplicate?: () => void;
  onDelete?: () => void;
  onSplit?: () => void;
  onViewDetails: () => void;
  disabled?: boolean;
  canSplit?: boolean;
  readOnlyMode?: boolean;
}

export const BookingInlineActions: React.FC<BookingInlineActionsProps> = ({
  booking,
  onDuplicate,
  onDelete,
  onSplit,
  onViewDetails,
  disabled = false,
  canSplit = true,
  readOnlyMode = false,
}) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          disabled={disabled}
          className="h-8 w-8 hover:bg-accent text-muted-foreground hover:text-foreground"
        >
          <MoreVertical className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={onViewDetails}>
          <Info className="h-4 w-4 mr-2" />
          View Details
        </DropdownMenuItem>
        
        {!readOnlyMode && (
          <>
            <DropdownMenuSeparator />
            
            {onDuplicate && (
              <DropdownMenuItem onClick={onDuplicate} disabled={disabled}>
                <Copy className="h-4 w-4 mr-2" />
                Duplicate
              </DropdownMenuItem>
            )}
            
            {onDelete && (
              <DropdownMenuItem 
                onClick={onDelete} 
                disabled={disabled}
                className="text-destructive focus:text-destructive"
              >
                <Trash2 className="h-4 w-4 mr-2" />
                Delete
              </DropdownMenuItem>
            )}
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
